module.exports = __webpack_public_path__ + "img/bck.392dd41a.png";